import { action, flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { getStorage, removeStorage, saveLocalStorage } from '@/utils/browsers';
import { AuthApi } from '@/apis';
import { ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import { t } from 'i18next';
import { Profile } from '@/types/auth';
import { ResponseData } from '@/types/http';
import { ChangePasswordRequest, ForgotPasswordPostRequest, ForgotPasswordPostResponse, ResendOtpPostRequest, ResendOtpPostResponse, ResetPasswordPostRequest, ResetPasswordPostResponse, SignInPostRequest, SignInPostResponse, VerifyOtpPostRequest, VerifyOtpPostResponse, VerifyUuidPostRequest, VerifyUuidPostResponse } from '@/types/http-payload/auth';

export default class AuthStore extends BaseStore {
    profile?: Profile;
    token: string = getStorage('token');
    api: AuthApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            profile: observable,
            token: observable,
            signIn: flow.bound,
            signOut: action.bound,
            getProfile: flow.bound,
            forgotPassword: flow.bound,
            verifyOtp: flow.bound,
            resetPassword: flow.bound,
            resendOtp: flow.bound,
            verifyUuid: flow.bound,
            changePassword: flow.bound,
            clearAuthentication: action.bound
        });
        this.api = new AuthApi();
    }

    *signIn(payload: SignInPostRequest) {
        try {
            const res: ResponseData<SignInPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.signIn, payload);
            if (res?.ok) {
                this.token = res.data.token;
                saveLocalStorage('token', res.data.token);
                toastify('success', t('messages.sign_in_success'));
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *getProfile() {
        try {
            const res: ResponseData<Profile> = yield this.rootStore.apiStore.call(this.api, this.api.getProfile);
            if (res?.ok) {
                this.profile = res.data;
            }
        } catch (error) {
        }
    }

    *forgotPassword(payload: ForgotPasswordPostRequest) {
        try {
            const res: ResponseData<ForgotPasswordPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.forgotPassword, payload);
            if (res?.ok) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *resetPassword(payload: ResetPasswordPostRequest) {
        try {
            const res: ResponseData<ResetPasswordPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.resetPassword, payload);
            if (res?.ok) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *changePassword(payload: ChangePasswordRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.changePassword, payload);
            if (res?.ok) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *verifyOtp(payload: VerifyOtpPostRequest) {
        try {
            const res: ResponseData<VerifyOtpPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.verifyOtp, payload);
            if (res?.ok) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *verifyUuid(payload: VerifyUuidPostRequest) {
        try {
            const res: ResponseData<VerifyUuidPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.verifyUuid, payload);
            if (res?.ok) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *resendOtp(payload: ResendOtpPostRequest) {
        try {
            const res: ResponseData<ResendOtpPostResponse> = yield this.rootStore.apiStore.call(this.api, this.api.resendOtp, payload);
            if (res?.ok) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    signOut() {
        try {
            this.rootStore.apiStore.call(this.api, this.api.signOut);
            this.clearAuthentication();
        } catch (error) {
        }
    }

    clearAuthentication() {
        removeStorage(['token', 'profile']);
        window.location.href = ROUTES.signIn.href;
    }
}
